import { API, Endpoints } from '@brg/api';
import { useCallback } from 'react';

type SaveParams = {
    id: string;
    moduleId: string;
    userId: string;
    showLessonsSchedule: boolean;
};

export const useSaveScheduleVisibility = () => {
    const save = useCallback((params: SaveParams) => {
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/SaveModuleUserSettings')
            .post()
            .body(params)
            .send()
            .catch(() => {});
    }, []);

    return { save };
};
import { API, Endpoints } from '@brg/api';
import { useCallback } from 'react';

type SaveParams = {
    id: string;
    moduleId: string;
    userId: string;
    showLessonsSchedule: boolean;
};

export const useSaveScheduleVisibility = () => {
    const save = useCallback((params: SaveParams) => {
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/SaveModuleUserSettings')
            .post()
            .body(params)
            .send()
            .catch(() => {});
    }, []);

    return { save };
};
